import React, { useState } from "react";
import moment from "moment";
import { VenueModel } from "Services/API/API";
import { Button } from "Components/ReactstrapSlim";
import { ReservationCalendarSelectionState } from "./ReservationCalendarSelection";
import { ReservationCalendarLegend } from "./ReservationCalendarLegend";
import { ReservationCalendarBody } from "./ReservationCalendarBody";
import classes from "../styles.module.scss";
import { splitDateAndTime } from "Utils/date";
import { BIN } from "features/ComponentsLib";

interface ReservationCalendarProps {
   venue: VenueModel,
   /** yyyy-MM-DD */
   selectedDate: string | undefined,
   container?: HTMLElement | string,
   toggle: () => void,
   refreshUpcomingReservationList?: () => void,
   setIsHidden(state: boolean): void;
}

const ReservationCalendar: React.FC<ReservationCalendarProps> = ({ venue, selectedDate, container, toggle, refreshUpcomingReservationList, setIsHidden }) => {
   const [calendarSelection, setCalendarSelection] = useState<ReservationCalendarSelectionState | undefined>(undefined);
   const [calendarDate, setCalendarDate] = useState<moment.Moment | undefined>(undefined);

   const onBINclosed = (isSuccess: boolean) => {      
      if (!isSuccess)
         setIsHidden(false);
      else {
         if (refreshUpcomingReservationList)
            refreshUpcomingReservationList();
         toggle();
      }
   }

   const openBIN = () => {
      if (calendarSelection?.startColIndex !== undefined && calendarSelection?.endColIndex !== undefined && calendarDate && calendarSelection.rowId) {
         const startMoment = moment({ year: calendarDate.year(), month: calendarDate.month(), date: calendarDate.date(), hour: calendarSelection.startColIndex, minute: 0, second: 0, millisecond: 0 });
         const durationMinutes = (calendarSelection.endColIndex - calendarSelection.startColIndex + 1) * 60;
         const [startDate, startTime] = splitDateAndTime(startMoment.toDate())
         BIN({
            type: "NEW",
            venueId: venue.id,
            workspaceId: calendarSelection.rowId,
            startDate: startDate,
            startTime: startTime,
            durationMinutes: durationMinutes,
            //daysAhead: 7,
            onClose: onBINclosed,
            //successCallBack: onReservationCreated,
            //daysAhead: LSHelper.Constants.reservationSearchDaysAhead(),
            //reservationSourcePage: LSHelper.Calendar.ReservationSourceNames.XPP
         });

         setIsHidden(true);
      }
   }

   return <>
      <ReservationCalendarBody venueId={venue.id} date={selectedDate} onSelectionChanged={setCalendarSelection} onDateChanged={setCalendarDate} timeZone={venue.timeZone} container={container} />
      <div className={classes.footer}>
         <ReservationCalendarLegend className={classes.legend} />
         <div className={classes.cta}>
            <Button className={classes.ctaCancel} size="lg" color="secondary" onClick={toggle}>Cancel</Button>
            <Button className={classes.ctaSubmit} size="lg" color="primary" onClick={openBIN} disabled={calendarSelection?.startColIndex === undefined}>Continue</Button>
         </div>
      </div>
   </>
}

export default ReservationCalendar;